'use client'
import clsx from "clsx"
import Link from "next/link"
import { useEffect, useState } from "react"


const menu = [
    { title: "Início", anchor: 'inicio', dataLayerEnvent: {} },
    { title: "Como participar", anchor: 'conheca-os-sorteados', dataLayerEnvent: {} },
    { title: "O sorteio", anchor: 'o-sorteio', dataLayerEnvent: {} },
    { title: "Simule agora", anchor: 'simule-agora', dataLayerEnvent: {} },
    { title: "Perguntas frequentes", anchor: 'perguntas-frequentes', dataLayerEnvent: {} }
]

export const NavMenu = () => {
    const [activeSession, setActiveSession] = useState('inicio')



    useEffect(() => {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                setActiveSession(entry.target.id);
              }
            });
          },
          { threshold: 0.5 }
        );
    
        const sections = document.querySelectorAll('section');
        sections.forEach((section) => observer.observe(section));
    
        return () => observer.disconnect();
      }, []);

    return (
        <div className="h-mobile flex-1 w-full max-w-[880px] h-full">
            <ul className="flex justify-evenly h-full">
                {menu.map((item, index) => {
                    return (
                        <li key={index} className="relative">
                            <Link onClick={() => setActiveSession(item.anchor)} className={clsx("relative flex flex-col h-full px-2 items-center justify-center text-center text-white overflow-hidden", {
                                'font-bold':  activeSession === item.anchor
                            })} href={`#${item.anchor}`}>{item.title}</Link>
                            {activeSession === item.anchor && <span className="absolute left-0 bottom-0 h-1 w-full bg-white transition-all duration-300" />}
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}